<template>
    <div class="c-dashboard"
        :data-component-name="$options.name"
    >
        <WeekViewFooter
            :currentDate="currentDate"
            :weekrange="weekrange"
            @set-current-date="$emit('set-current-date', $event)"
            @set-date-offset="dateOffset=$event"
            @set-more-filters="moreFilters=$event"
        />
        <Projects
            :moreFilters="moreFilters"
            :scrollToProject="scrollToProject"
            :projectDateRange="weekrange"
            :projectIDs="projectIDs"
            :currentDate="currentDate"
            :shiftsView="shiftsView"
            :projectsFilter="projectsFilter"
            :newProject="newProject"
            @set-current-date="$emit('set-current-date', $event)"
            ref="projects"
            @cancel="newProject=false"
            class="c-dashboard-rows"
        />

        <FloatingControls
            @new-project="createNewProject()"
        />
        <div class="c-dashboard__bg">
            <div class="c-dashboard-row -week">
                <div class="c-dashboard__item -control -left"></div>
                <div class="c-dashboard__item -week">
                    <div class="c-dashboard-day__wrap"
                        :key="index"
                        v-for="(weekday, index) in weekdays"
                        :class="{ 'weekend' : weekday.getDay()==0 || weekday.getDay()==6 }"
                    ></div>
                </div>
                <div class="c-dashboard__item -control -right"></div>
            </div><!-- .c-dashboard-row .-project-desc -->
		</div>
    </div>
</template>

<script>
    // import NewProjectModal from '@/components/projects/NewProjectModal'
    import WeekViewFooter from "@/components/nav/WeekViewFooter";
    import Projects from '@/components/projects/Projects'
    import FloatingControls from '@/components/nav/FloatingControls'
    import {getWeeksLimits, getDatesBetween} from '@/js/dateUtilities'

    export default {
        name: 'WeekView',
        components: {
            WeekViewFooter,
            Projects,
            FloatingControls,
            // NewProjectModal
        },
        props: {
            currentDate: String,
            shiftsView: {
                type: String,
                default: 'profession'
            },
            projectsFilter: {
                type: String,
                default: 'All'
            },
            scrollToProject: {
                type: String,
                default: null
            }
        },
        data(){
            return {
                projectIDs: [],
                newProject: false,
                dateOffset: parseInt(this.$generalSettings.settings.firstDayOfWeek)+0,
                moreFilters: null
            }
        },
        computed: {
            weekrange(){
                return getWeeksLimits(this.currentDate, this.dateOffset)
            },
            weekdays(){
                let dateRange=getDatesBetween(this.weekrange.obj.from, this.weekrange.obj.to)
                return dateRange;
            }
        },
        mounted(){
            this.$eventBus.$emit('clear-more-filters');
        },
        methods: {
            createNewProject(){
                this.newProject=true
                setTimeout(function(){
                    this.$scrollTo('#project0', 200, {offset:-100})
                }.bind(this), 200)
            },
            refetchProjects(){
                this.$refs.projects.refetchProjects();
            }
        }
    }
</script>

<style lang="scss">
    @import "@/scss/components/dashboard/WeekView.scss";
</style>
